import { createSelector } from 'reselect'

import { selectPartnerSearchState } from './selectPartnerSearchState'

export const selectLoadingStatus = createSelector(
  [selectPartnerSearchState],
  ({ status }) => status
)
